"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Download } from "lucide-react";

export default function FloatingDownloadButton() {
  const pathname = usePathname();

  if (pathname === "/app-download") {
    return null;
  }

  return (
    <Link
      href="/app-download"
      aria-label="Open app download page"
      className="fixed bottom-5 right-5 z-[70] inline-flex items-center gap-2 rounded-full bg-[#ffbf00] px-4 py-3 text-[#1d2838] shadow-[0_14px_34px_-12px_rgba(244,73,0,0.85)] transition-transform hover:-translate-y-1 hover:bg-[#ffd24a] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#ffbf00] focus-visible:ring-offset-2"
    >
      <Download className="h-4 w-4" />
      <span className="text-sm font-semibold">Get Zuma AI App</span>
    </Link>
  );
}
